// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"styles-module--section-header--wWPOR","textIcon":"styles-module--text-icon--11Jqy"};